import React from "react";
import MerchantSettleListPanel from "../../components/merchantSettle/MerchantSettleListPanel";

const ExpenseTransactions = ({ merchants, active }) => (
  <MerchantSettleListPanel
    mode="admin"
    merchantOptions={merchants}
    active={active}
    tableScrollY="calc(100vh - 38vh)"
    defaultPageSize={20}
  />
);

export default ExpenseTransactions;
